import React, { useState } from 'react';
import { useProjects } from '../context/ProjectContext';
import ListView from '../components/views/ListView';
import KanbanView from '../components/views/KanbanView';
import GanttView from '../components/views/GanttView';
import ProjectForm from '../components/ProjectForm';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Projects = () => {
  const { projects, addProject, updateProject, archiveProject, deleteProject } = useProjects();
  const [view, setView] = useState('list');
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [filter, setFilter] = useState('All');

  const filteredProjects = projects.filter(p => {
    if (filter === 'All') return p.status !== 'Archived';
    return p.department === filter && p.status !== 'Archived';
  });

  const handleCreate = () => {
    setEditingProject(null);
    setIsFormOpen(true);
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setIsFormOpen(true);
  };

  const handleSave = (projectData) => {
    if (editingProject) {
      updateProject(editingProject.id, projectData);
    } else {
      addProject(projectData);
    }
    setIsFormOpen(false);
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex items-center bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
          {['list', 'kanban', 'gantt'].map((v) => (
            <button
              key={v}
              onClick={() => setView(v)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition capitalize flex items-center gap-2 ${
                view === v 
                  ? 'bg-white dark:bg-gray-700 shadow-sm text-indigo-600 dark:text-white' 
                  : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              <SafeIcon icon={v === 'list' ? FiIcons.FiList : v === 'kanban' ? FiIcons.FiGrid : FiIcons.FiActivity} />
              {v}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <select 
            value={filter} 
            onChange={(e) => setFilter(e.target.value)}
            className="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm focus:outline-none dark:text-white"
          >
            <option>All</option>
            <option>Marketing</option>
            <option>Sales</option>
            <option>HR</option>
            <option>Product</option>
            <option>Leadership</option>
            <option>R&A</option>
            <option>ExCo</option>
            <option>Eco Teams</option>
            <option>Internal Comms</option>
            <option>External Comms</option>
          </select>
          
          <button 
            onClick={handleCreate}
            className="flex items-center gap-2 px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition shadow-lg shadow-indigo-500/30"
          >
            <SafeIcon icon={FiIcons.FiPlus} />
            <span>New Project</span>
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-auto min-h-[400px]">
        {view === 'list' && (
          <ListView 
            projects={filteredProjects} 
            onEdit={handleEdit} 
            onArchive={archiveProject}
            onDelete={deleteProject}
          />
        )}
        {view === 'kanban' && (
          <KanbanView 
            projects={filteredProjects} 
            onEdit={handleEdit} 
          />
        )}
        {view === 'gantt' && (
          <GanttView 
            projects={filteredProjects} 
          />
        )}
      </div>

      {isFormOpen && (
        <ProjectForm 
          project={editingProject} 
          onClose={() => setIsFormOpen(false)} 
          onSave={handleSave} 
        />
      )}
    </div>
  );
};

export default Projects;